import { z } from "zod";

/**
 * Public HALO GitHub repository stats (`marketing.getHaloGitHubStats`).
 * `stargazerCount` is null when the upstream GitHub fetch fails.
 */
export const haloGitHubStatsSchema = z.object({
  stargazerCount: z.number().int().nonnegative().nullable(),
});
